import { render, staticRenderFns } from "./GroupResult.vue?vue&type=template&id=653c02cf"
import script from "./GroupResult.vue?vue&type=script&lang=js"
export * from "./GroupResult.vue?vue&type=script&lang=js"
import style0 from "./GroupResult.vue?vue&type=style&index=0&id=653c02cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports